type ApplyAuthTokenArgs = {
  token?: string | null
  cookieAuthEnabled: boolean
  establishCookieSession: (token: string) => Promise<void>
  setAuthToken: (token: string) => void
}

export const applyAuthToken = async ({
  token,
  cookieAuthEnabled,
  establishCookieSession,
  setAuthToken,
}: ApplyAuthTokenArgs): Promise<void> => {
  if (!token) return

  if (cookieAuthEnabled) {
    await establishCookieSession(token)
    return
  }

  setAuthToken(token)
}
